"use strict";
/*
 * Created on 10 11 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var VAT_1 = require("../model/VAT");

var VATRate_1 = require("../model/VATRate");

var VATConverter_1 = require("./VATConverter");
/**
 * Implementation of {@link VATConverter}
 *
 * @author JMe
 */


var VATConverterImpl =
/*#__PURE__*/
function (_VATConverter_1$VATCo) {
  _inherits(VATConverterImpl, _VATConverter_1$VATCo);

  function VATConverterImpl() {
    _classCallCheck(this, VATConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(VATConverterImpl).apply(this, arguments));
  }

  _createClass(VATConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        name: source.name,
        shortName: source.shortName,
        rates: conversions.asObjectArray(source, 'rates', this.serializeVATRate(conversions))
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new VAT_1.VAT(VAT_1.VAT.schema.id.valueOf(conversions.documentToClassId(source)), VAT_1.VAT.schema.externalId.valueOfField(source), VAT_1.VAT.schema.name.valueOfField(source), VAT_1.VAT.schema.shortName.valueOfField(source), conversions.asObjectList(source, 'rates', this.deserializeVATRate(conversions)));
    }
  }, {
    key: "deserializeVATRate",
    value: function deserializeVATRate(conversions) {
      return function (document) {
        return new VATRate_1.VATRate(conversions.toDate(document.validFrom), conversions.toDate(document.validTo), conversions.toBigNumber(document.rate));
      };
    }
  }, {
    key: "serializeVATRate",
    value: function serializeVATRate(conversions) {
      return function (object) {
        return {
          validFrom: conversions.fromDate(object.validFrom),
          validTo: conversions.fromDate(object.validTo),
          rate: conversions.fromBigNumber(object.rate)
        };
      };
    }
  }]);

  return VATConverterImpl;
}(VATConverter_1.VATConverter);

exports.VATConverterImpl = VATConverterImpl;